import * as yup from "yup"

export const initialValues = {
  fullName: "",
  email: "",
  phoneNumber: "",
  city: "",
  stateProvince: "",
  country: "",
  subject: "",
  message: "",
  recaptcha: "",
}

export default yup.object().shape({
  fullName: yup.string().required("Full name is required"),
  email: yup.string().email("Invalid email").required("Email is required"),
  phoneNumber: yup.string().required("Phone number is required"),
  city: yup.string().required("City is required"),
  stateProvince: yup.string().required("State or province is required"),
  country: yup.string().required("Country is required"),
  subject: yup.string().required("Subject is required"),
  message: yup.string().required("Message is required"),
})

export const withRecaptcha = yup.object().shape({
  fullName: yup.string().required("Full name is required"),
  email: yup.string().email("Invalid email").required("Email is required"),
  phoneNumber: yup.string().required("Phone number is required"),
  city: yup.string().required("City is required"),
  stateProvince: yup.string().required("State or province is required"),
  country: yup.string().required("Country is required"),
  message: yup.string().required("Message is required"),
  subject: yup.string().required("Subject is required"),
  recaptcha: yup.string().required(),
})
